module.exports = __webpack_public_path__ + "static/Hero-3858fa48c895e3ea35fa02520afe04ee.jpg";